// extracted by mini-css-extract-plugin
export default {"signupContainer":"signup_signupContainer__S0gMB","leftSection":"signup_leftSection__Dcb+I","rightSection":"signup_rightSection__0WXFB"};